<template>
  <div class="profile-container-new" @scroll="getScrollPos" id="profile-container-new" v-if="profile ? true : false">
    <div class="overlay-container">
      <i @click="$router.go(-1)" class="material-icons white--text pointer">keyboard_arrow_left</i>
      <!-- more-options -->
      <div class="more-vert-icon">
        <!-- DROPDOWN -->
        <div class="dropdown-container" tabindex="0" @focusout="showMoreOptionDialog = false">
          <!-- ICON -->
          <i
            class="material-icons white--text pointer"
            @click="showMoreOptionDialog = !showMoreOptionDialog"
            v-if="profile.uid === user.uid"
          >more_vert</i>

          <!-- CARD -->
          <div v-if="showMoreOptionDialog" class="dropdown-card-container">
            <div class="logout-text" @click="logout(); $router.push('/?loc=Worldwide')">Logout</div>
          </div>
        </div>
        <!-- /DROPDOWN -->
      </div>
      <!-- /more-options -->
    </div>

    <!-- cover -->
    <img
      :src="profileFallBackImage()"
      v-if="profile.cover === null || checkVideo(profile.cover)"
      class="profile-cover-image"
    />
    <img
      :src="listviewImage(profile.cover,profile)"
      class="profile-cover-image"
      v-else
    />
    <!-- /cover -->

    <!-- uploader's details desktop -->
    <div class="uploader-details-desktop">
      <img
        :src="profile.dp"
        class="profile-image"
        :style="profile.uid === user.uid?'cursor:pointer':''"
        v-if="profile.dp !== null"
        @click="profile.uid === user.uid?createModelObj():''"
      />

      <div class="other-details">
        <button class="upload-image-button" @click="goToUpload" v-if="profile.uid === user.uid">
          <i class="material-icons">photo_camera</i> Submit a photo/video
        </button>
        <div class="name-uploader-links">
          <!-- name -->
          <div class="name">{{cropUsername(profile.name)}}</div>
          <!-- /name -->

          <!-- likes-and-popularity -->
          <!-- <div class="likes-and-popularity">

          <div class="popularity">
            <span class="count">{{profile.exposures_on_my_photo}}</span> Popularity
          </div>
          <div class="likes">
            <span class="count">{{profile.likes}}</span> Likes
          </div>
          </div>-->
          <!-- /likes-and-popularity -->
          <!-- uploader's links -->
          <div class="links">
            <!-- <div
              v-if="profile.website != ''"
              class="website"
              @click="openInTab(profile.website)"
            >{{profile.website}}</div>-->

            <!-- for testing only<div class="social-links">
              <img height="18px" src="../../static/img/insta_BandW.svg" />
              <img height="18px" src="../../static/img/fb_Band W.svg" />
              <img height="18px" src="../../static/img/twitter_BandW.svg" />
            </div>-->
            <!-- <div
              v-if="profile.website != ''"
              class="website"
              @click="openInTab(profile.website)"
            >{{profile.website}}</div>-->

            <div class="social-links">
              <img
                v-if="profile.social ? profile.social.instagram != '': false"
                @click="openInTab(profile.social.instagram)"
                height="18px"
                src="../../static/img/insta_BandW.svg"
              />
              <img
                v-if="profile.social ? profile.social.facebook != '': false"
                @click="openInTab(profile.social.facebook)"
                height="18px"
                src="../../static/img/fb_Band W.svg"
              />
              <img
                v-if="profile.social ? profile.social.twitter != '' && profile.social.twitter != undefined : false"
                @click="openInTab(profile.social.twitter)"
                height="18px"
                src="../../static/img/twitter_BandW.svg"
              />
            </div>
            <!-- edit-profile-button -->
            <button
              class="edit-profile-button"
              v-if="profile.uid === user.uid"
              @click="profileEditDialog = true; createModelObj()"
            >
              <i class="material-icons white--text">edit</i>
            </button>
            <!-- /edit-profile-button -->
          </div>
          <!-- /uploader's links -->
        </div>
        <!-- bio -->
        <div class="bio">{{profile.desc}}</div>
        <!-- /bio -->
      </div>
    </div>

    <!-- /uploader's details desktop-->

    <!-- uploader's details mobile -->
    <div class="uploader-details-mobile">
      <button class="upload-image-button" @click="goToUpload" v-if="profile.uid === user.uid">
        <i class="material-icons">photo_camera</i> Submit a photo/video
      </button>
      <img
        :src="profile.dp"
        class="profile-image"
        v-if="profile.dp !== null"
        :style="profile.uid === user.uid?'cursor:pointer':''"
        @click="profile.uid === user.uid?createModelObj():''"
      />

      <div class="other-details">
        <div class="name-uploader-links">
          <!-- name -->
          <div class="name">{{cropUsername(profile.name)}}</div>
          <!-- /name -->

          <!-- likes-and-popularity -->
          <!-- <div class="likes-and-popularity">

          <div class="popularity">
            <span class="count">{{profile.exposures_on_my_photo}}</span> Popularity
          </div>
          <div class="likes">
            <span class="count">{{profile.likes}}</span> Likes
          </div>
          </div>-->
          <!-- /likes-and-popularity -->
          <!-- uploader's links -->
          <div
            class="links"
            v-if="profile.social ? profile.social.instagram != '' || profile.social.facebook != ''|| profile.social.facebook != '' :  false"
          >
            <!-- <div
              v-if="profile.website != ''"
              class="website"
              @click="openInTab(profile.website)"
            >{{profile.website}}</div>-->

            <!--for testing only  <div class="social-links">
              <img height="18px" src="../../static/img/insta_BandW.svg" />
              <img height="18px" src="../../static/img/fb_Band W.svg" />
              <img height="18px" src="../../static/img/twitter_BandW.svg" />
            </div>-->
            <!-- <div
              v-if="profile.website != ''"
              class="website"
              @click="openInTab(profile.website)"
            >{{profile.website}}</div>-->

            <div class="social-links">
              <img
                v-if="profile.social ? profile.social.instagram != '': false"
                @click="openInTab(profile.social.instagram)"
                height="18px"
                src="../../static/img/insta_BandW.svg"
              />
              <img
                v-if="profile.social ? profile.social.facebook != '': false"
                @click="openInTab(profile.social.facebook)"
                height="18px"
                src="../../static/img/fb_Band W.svg"
              />
              <img
                v-if="profile.social ? profile.social.twitter != '' && profile.social.twitter != undefined: false"
                @click="openInTab(profile.social.twitter)"
                height="18px"
                src="../../static/img/twitter_BandW.svg"
              />
            </div>
            <!-- edit-profile-button -->

            <!-- /edit-profile-button -->
          </div>
          <!-- /uploader's links -->
        </div>
        <!-- bio -->
        <div class="bio">{{profile.desc}}</div>
        <!-- /bio -->
      </div>
      <button
        class="edit-profile-button-mobile"
        v-if="profile.uid === user.uid"
        @click="profileEditDialog = true; createModelObj()"
      >
        <i class="material-icons white--text">edit</i>
      </button>
    </div>
    <!--/uploader details mobile-->

    <!-- images -->
    <div class="uploader-counts-and-tab">
      <!-- uploader-name -->
      <!-- <div class="uploader-name">
        {{profile.name}}
      </div>-->
      <!-- /uploader-name -->

      <div class="uploader-tabs">
        <div
          class="tab-section"
          :style="selectedCount=='shared'? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;': ''"
          @click="selectedCount='shared', $router.replace(`/profile?selected_tab=shared&profile_id=${$route.query.profile_id}`);
              getLocation()"
        >
          <div class="tab pointer">SUBMITTED</div>
          <div class="tab-count">{{profile.shared}}</div>
        </div>

        <div
          class="tab-section"
          :style="selectedCount=='checkins'? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;': ''"
          @click="selectedCount='checkins', $router.replace(`/profile?selected_tab=checkins&profile_id=${$route.query.profile_id}`);
              getLocation()"
        >
          <div class="tab pointer">TRAVEL LIST</div>
          <div class="tab-count">{{profile.checkins}}</div>
        </div>

        <div
          class="tab-section"
          :style="selectedCount=='likes'? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;': ''"
          @click="selectedCount='likes', $router.replace(`/profile?selected_tab=likes&profile_id=${$route.query.profile_id}`);
              getLocation()"
        >
          <div class="tab pointer">LIKED</div>
          <div class="tab-count">{{profile.likes}}</div>
        </div>
      </div>
    </div>

    <!-- <div class="image-view-mode">
      <i class="material-icons"
         :style="showGrid? 'color: white': ''"
         @click="showGrid = true">grid_on</i>
      <i class="material-icons"
         :style="!showGrid? 'color: white': ''"
         @click="showGrid = false">map</i>
    </div>-->

    <div class="images">
      <v-container grid-list-xs v-if="$store.state.userProfile.profileImages.length != 0">
        <v-layout row wrap style="padding-bottom: 8em">
          <v-flex
            xs6
            sm4
            md2
            v-for="(img,imgIndex) in $store.state.userProfile.profileImages"
            :key="imgIndex"
          >
            <div
              class="img-height"
              @click="$router.push(`/id/${img.id}?inapp=true`)"
              v-if="img.resourceType=='image'"
            >
              <v-lazy-image :src="mapViewImage(img.id,img)" />
            </div>
            <div class="img-height" @click="$router.push(`/id/${img.id}?inapp=true`)" v-else>
              <div class="overlay"></div>
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe
                  :src="getVideoEmbedLink(img.id)"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- <div v-else>
        <mapView :is-child="true" v-if="!hideMap" :arr="$store.state.userProfile.profileImages" />
      </div>-->
      <div v-else class="bottom-space"></div>
    </div>
    <!-- /images -->

    <!-- footer -->
    <div class="user-footer-bottom" id="user-footer">
      <div class="footer-icons option-container">
        <button @click="goToHome()">
          <img height="12" class="wav-icon-footer" src="../../static/img/wav-icon.png" />
          <!--i class="material-icons">home</i-->
        </button>
        <span @click="goToHome()">Home</span>
      </div>
      <div class="footer-icons option-container">
        <button @click="goToUpload">
          <i class="material-icons">photo_camera</i>
        </button>
        <span @click="goToUpload">Add Photo</span>
      </div>
      <div class="footer-icons option-container">
        <button @click="$router.push({path:'/'})">
          <i class="material-icons">reorder</i>
        </button>
        <span
          @click="clickedMode('list');
             $store.state.common.swichModesBG = false"
        >List view</span>
      </div>
      <div class="footer-icons option-container">
        <button @click="$router.push({path:'/filter', query: $route.query})">
          <i class="material-icons">search</i>
        </button>
        <span @click="$router.push({path:'/filter', query: $route.query})">Search</span>
      </div>
      <div class="footer-icons user_account option-container">
        <button
          :style="isLoggedIn? 'opacity: 1': ''"
          @click="refreshPage();
                  isLoggedIn?$router.push({path: '/profile',
                   query: {
                    uploader: 'user',
                   profile_Id: user.uid,
                   selected_tab: 'checkins'
                   }}):$router.push(`/login`)"
        >
          <i class="material-icons" v-if="!isLoggedIn && screenW < 768">account_circle</i>
          <i class="material-icons" v-if="!isLoggedIn && screenW > 768">perm_identity</i>
          <img
            :src="user.photoURL"
            v-if="isLoggedIn"
            style="height: 1.75rem; width: 1.75rem; border-radius: 100%;"
            alt="profile photo"
          />
        </button>
        <span
          @click="
          refreshPage();
                  isLoggedIn?$router.push({path: '/profile',
                   query: {
                   profile_Id: user.uid,
                   selected_tab: 'checkins'
                   }}):$router.push(`/login`)"
        >Me</span>
      </div>
    </div>
    <!-- /footer -->

    <!-- edit profile dialog -->
    <v-dialog v-model="profileEditDialog" width="300" style="z-index: 10">
      <v-card>
        <v-card-text v-if="profileEditDialog">
          <v-text-field label="Name" v-model="editProfile.name"></v-text-field>

          <!-- upload profile picture -->

          <a id="upload-profile-photo">
            <img
              v-if="editProfile.dp != ''"
              height="200px"
              width="100%"
              style="object-fit: cover"
              :src="editProfile.dp"
              @click="openCloudinaryProfileImageWidget"
            />
          </a>
            <div
            id="upload-profile"
            class="profileImageUpload"
            style="display: flex; align-items: center;"
          >
            <i style="font-size: 1.4em; color: #999999;margin-right: 10px" class="material-icons">cloud_upload</i>
            <div class="pointer" @click="openCloudinaryProfileImageWidget">
              Upload Profile Photo
            </div>
          </div>
          <!-- /upload profile picture -->

          <v-text-field label="Facebook" v-model="editProfile.social.facebook"></v-text-field>

          <v-text-field label="Instagram" v-model="editProfile.social.instagram"></v-text-field>

          <v-text-field label="Twitter" v-model="editProfile.social.twitter"></v-text-field>

          <v-textarea label="Description" v-model="editProfile.desc"></v-textarea>
          <!--v-text-field
            label="Location"
            v-model="editProfile.location"
          >
          </v-text-field-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog()" small outline class="grey blue--text">Cancel</v-btn>
          <v-btn
            @click="saveEditedProfileChanges"
            small
            outline
            class="blue blue--text"
          >Confirm Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /edit profile dialog -->
  </div>
</template>
<script>
import mapView from "./mapView";
import geo from "geo-hash";
import haversine from "haversine";
import InfiniteLoading from "vue-infinite-loading";
import geohash from "geo-hash";
import { mapGetters, mapMutations } from "vuex";
import bottom from "../components/common/bottomMenu";
import { ele } from "../helper/gen";
import imageLinks from "../mixin/imageLinks";
import cropUsername from "../mixin/cropUsername";
import cloudinaryCore from "cloudinary-core";
import configurations from "../configurations";
//
var cl = new cloudinaryCore.Cloudinary({
  cloud_name: configurations.cloudinary_cloudName,
  secure: true
});
var vm2;
export default {
  metaInfo() {
    return {
      title: "with a view"
    };
  },
  mixins: [imageLinks, cropUsername],
  data() {
    return {
      showGrid: true,
      cH: 0,
      cW: 0,
      uploader: {},
      editProfile: {},
      profileEditDialog: false,
      selectedCount: "",
      selectedSort: "newest",
      visitedIndices: [],
      showMoreOptionDialog: false
    };
  },
  mounted() {
    let vm = this;
    var prevScrollpos = window.pageYOffset;
    this.$store
      .dispatch("getProfileImageLink", this.editProfile)
      .then(async res => {});
    this.cW = 600;
    this.cH = 900;
  },
  created() {
    this.$store.state.userProfile.profileImages = [];
    vm2 = this;
    this.selectedCount =
      this.$route.query.selected_tab === undefined
        ? "checkins"
        : this.$route.query.selected_tab;

    let obj = JSON.parse(JSON.stringify(this.$route.query));
    if (obj.profile_id !== undefined) {
      this.$store.commit("getUserProfileDetails", {
        uid: obj.profile_id,
        uploader: "user"
      });
      vm2.$store.commit("getProfileImages", {
        uid: obj.profile_id,
        limit: 50,
        startAt: vm2.profileImages.length,
        tab: vm2.selectedCountName,
        orderBy: vm2.selectedSort,
        geohash: vm2.profileGeolocation,
        isRandom: false
      });
    } else {
      if (this.isLoggedIn) {
        this.$router.replace(
          `/profile?selected_tab=${this.selectedCount}&profile_id=${this.user.uid}`
        );
      } else {
        this.$router.push("/login");
      }
    }
  },
  watch: {
    showGrid: function() {
      if (!this.hideMap && !this.showGrid) {
        this.calScroll();
      }
    },
    "$store.state.userProfile.hideMap": {
      handler() {
        if (!this.hideMap && !this.showGrid) {
          this.calScroll();
        }
      }
    },
    "$store.state.common.toggleForAddToWishlist": {
      handler() {
        for (let i in this.$store.state.userProfile.profileImages) {
          if (
            this.$store.state.userProfile.profileImages[i].photoId ===
            this.$store.state.common.imageDetParticular
          ) {
            this.changeLikesCnt(i);
            this.$modal.hide("ask-to-add-to-wishlist");
          }
        }
      }
    },
    "$store.state.userProfile.profileImages": {
      handler() {
        vm2.calDistance();
      },
      deep: true
    },
    "$store.state.gen.finalUserLocation": () => {
      if (
        vm2.$store.state.gen.finalUserLocation === "" &&
        vm2.selectedSort === "nearest"
      ) {
        vm2.$store.state.common.showOverlay = true;
      } else if (
        vm2.$store.state.gen.finalUserLocation !== "" &&
        vm2.selectedSort !== "nearest"
      ) {
        vm2.calDistance();
      } else {
        this.getLocation();
      }
      //  vm2.getLocation()
    },
    "$route.query.selected_tab": () => {
      vm2.selectedCount = vm2.$route.query.selected_tab;
    },
    "$route.query.profile_id": () => {
      vm2.$store.commit("getUserProfileDetails", {
        uid: vm2.$route.query.profile_id,
        uploader: vm2.$route.query.uploader
      });
      vm2.$store.commit("getProfileImages", {
        uid: vm2.$route.query.profile_id,
        limit: 50,
        startAt: vm2.profileImages.length,
        tab: vm2.selectedCountName,
        orderBy: vm2.selectedSort,
        geohash: vm2.profileGeolocation,
        isRandom: false
      });
    },
    "$store.state.userProfile.live_profile_pic": () => {
      vm2.editProfile.dp = vm2.$store.state.userProfile.live_profile_pic;
    },
    selectedSort: function() {
      this.getLocation();
    }
  },
  methods: {
    ...mapMutations([
      "getUserProfileDetails",
      "operationOnPhoto",
      "goToImageDetMap",
      "logout",
      "openCloudinaryProfileImageWidget"
    ]),
    refreshPage() {
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    },
    getVideoEmbedLink(videoId) {
      var id = videoId.split("_")[1];
      if (videoId.match("^vmvdo")) {
        return `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0`;
      } else {
        return `https://www.youtube.com/embed/${id}?rel=0&mute=1&modestbranding=1&autohide=1&showinfo=0&iv_load_policy=3&enablejsapi=1&loop=1`;
      }
    },
    checkVideo(photoId) {
      if(photoId){
        if (photoId.match("^vmvdo") || photoId.match("^ytvdo")) {
          return true;
        } else {
          return false;
        } 
      }else{
        return false;
      }
    },
    getScrollPos() {
      let ele = document.getElementsByClassName("profile-container-new")[0];
      let totalHeight = ele.scrollHeight;
      let currentScroll = ele.scrollTop;

      if (
        currentScroll <= totalHeight - 100 &&
        !this.hideMap &&
        this.showGrid &&
        !this.$store.state.userProfile.noCalls
      ) {
        // this.$store.commit("getProfileImages", {
        //   uid: this.$route.query.profile_id,
        //   limit: 50,
        //   startAt: this.profileImages.length,
        //   tab: this.selectedCountName,
        //   orderBy: this.selectedSort,
        //   geohash: this.profileGeolocation
        // });
      }
      if (currentScroll > 100) {
        document.getElementById("user-footer").style.bottom = "0";
      }
    },
    goToUpload() {
      //alert(this.$store.state.auth.isLoggedIn)
      if (this.$store.state.auth.isLoggedIn) {
        //alert(`0`)
        this.$router.push("/upload-0");
      } else {
        //alert(`1`)
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg:
            "Please sign-in to complete this action. It takes only a few seconds."
        });
      }
    },
    getLoc() {
      if (this.finalUserLocation != "") this.getLocation();
      else {
        setTimeout(() => {
          this.getLoc();
        }, 100);
      }
    },
    openInTab(link) {
      window.open(link, "_blank");
    },
    async changeCheckinsCnt(index) {
      let vm = this;
      if (this.user.uid === undefined) {
        this.$store.commit("snackbar_alert", {
          msg: "Please sign-in to like it. It takes only a few seconds."
        });
        this.$router.push("/login");
        return;
      }

      let img = this.$store.state.userProfile.profileImages[index];
      let status = await this.$store.dispatch("operationOnPhoto", {
        pid: img.photoId,
        uid: vm.user.uid,
        operation: "checkin"
      });

      //  if(this.uploader.uploaderId === this.user.uid ) {
      if (
        this.selectedCount === "check-ins" &&
        this.uploader.uploaderId === this.user.uid
      ) {
        this.$store.state.userProfile.profileImages.splice(index, 1);
        this.$store.state.userProfile.maxProfileImg =
          parseInt(this.$store.state.userProfile.maxProfileImg) - 1;
      }
      // else {
      if (status === "added") {
        this.$store.state.userProfile.profile.checkins++;
        img.isCheckedin = true;
        img.checkins++;
      } else {
        this.$store.state.userProfile.profile.checkins--;
        img.isCheckedin = false;
        img.checkins--;
      }

      let localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        for (let i in localStorageElem.filteredImagesArr) {
          if (localStorageElem.filteredImagesArr[i].id === img.photoId) {
            localStorageElem.filteredImagesArr[i].checkins = img.checkins;
            localStorageElem.filteredImagesArr[i].isCheckedin = img.isCheckedin;
            localStorage.setItem(
              "homePageImages",
              JSON.stringify(localStorageElem)
            );
            break;
          }
        }
      }
    },
    async changeLikesCnt(index) {
      let vm = this;
      if (this.user.uid === undefined) {
        this.$store.commit("snackbar_alert", {
          msg:
            "Please sign in to complete your desired action.. It takes only a few seconds."
        });
        this.$router.push("/login");
        return;
      }
      let img = this.$store.state.userProfile.profileImages[index];
      let status = await this.$store.dispatch("operationOnPhoto", {
        pid: img.photoId,
        uid: vm.user.uid,
        operation: "like"
      });

      //  if(this.uploader.uploaderId === this.user.uid ) {
      if (
        this.selectedCount === "wishlist" &&
        this.uploader.uploaderId === this.user.uid
      ) {
        this.$store.state.userProfile.profileImages.splice(index, 1);
        this.$store.state.userProfile.maxProfileImg =
          parseInt(this.$store.state.userProfile.maxProfileImg) - 1;
      }
      // else {
      if (status === "added") {
        this.$store.state.userProfile.profile.likes++;
        img.isLiked = true;
        img.likes++;
      } else {
        this.$store.state.userProfile.profile.likes--;
        img.isLiked = false;
        img.likes--;
      }

      let localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        for (let i in localStorageElem.filteredImagesArr) {
          if (localStorageElem.filteredImagesArr[i].id === img.photoId) {
            localStorageElem.filteredImagesArr[i].likes = img.likes;
            localStorageElem.filteredImagesArr[i].isLiked = img.isLiked;
            localStorage.setItem(
              "homePageImages",
              JSON.stringify(localStorageElem)
            );
            break;
          }
        }
      }
      // }
    },
    goToHome() {
      let lsElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (screen.width < 600) {
        lsElem.isModeSwipe = true;
      }
      lsElem.swipeIndex = 0;
      localStorage.setItem("homePageImages", JSON.stringify(lsElem));
      this.$router.push("/?loc=Worldwide");
    },
    createModelObj() {
      this.profileEditDialog = true;
      let vm = this;
      this.editProfile = JSON.parse(JSON.stringify(vm.profile));
    },
    fadeOpen() {
      if (this.isbottomMenuOpen) {
        setTimeout(() => {
          ele(`bottom-menu`).style.opacity = 1;
        }, 100);
      }
    },
    closeDialog() {
      this.profileEditDialog = false;
    },
    saveEditedProfileChanges() {
      let vm = this;
      let payload = {
        profileUid: vm.user.uid,
        name: vm.editProfile.name,
        dp: vm.editProfile.dp,
        desc: vm.editProfile.desc,
        website: vm.editProfile.website,
        facebook: vm.editProfile.social.facebook,
        instagram: vm.editProfile.social.instagram,
        twitter: vm.editProfile.social.twitter
      };
      this.$store.dispatch("saveProfileChanges", payload).then(res => {
        this.profileEditDialog = false;
        (this.$store.state.userProfile.profile.social.facebook = this.editProfile.social.facebook),
          (this.$store.state.userProfile.profile.social.instagram = this.editProfile.social.instagram)(
            (this.$store.state.userProfile.profile.social.twitter = this.editProfile.social.twitter)
          );
        this.$store.state.userProfile.profile.name = this.editProfile.name;
        this.$store.state.userProfile.profile.dp = this.editProfile.dp;
        //this.$store.state.userProfile.profile.location = this.editProfile.location
        this.$store.state.userProfile.profile.desc = this.editProfile.desc;
        this.$store.state.userProfile.profile.website = this.editProfile.website;
        //this.$store.state.userProfile.profile.username = this.editProfile.username
      });
      setTimeout(function() {
        window.location.reload();
      }, 5000);
    },
    addToVisited(index) {
      if (this.visitedIndices.indexOf(index) === -1) {
        this.visitedIndices.push(index);
        this.visitedIndices.sort();
        if (
          this.visitedIndices[this.visitedIndices.length - 1] ===
          this.profileImages.length - 1
        ) {
          this.infiniteHandler();
        }
      }
    },
    infiniteHandler() {
      let vm = this;
      if (vm.profileImages.length === vm.maxProfileImg) {
        // $state.complete()
      } else {
        vm.$store.commit("getProfileImages", {
          uid: this.$route.query.profile_id,
          limit: 200,
          startAt: vm.profileImages.length,
          tab: vm.selectedCountName,
          orderBy: vm.selectedSort,
          geohash: vm.profileGeolocation
        });
      }
    },
    calDistance() {
      let vm = this;
      if (this.finalUserLocation != "") {
        for (let i in vm.$store.state.userProfile.profileImages) {
          if (vm.$store.state.userProfile.profileImages[i].hasGeohash) {
            let d1Lon = geo.decode(this.finalUserLocation);
            let d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
            let d2Lon = geo.decode(
              vm.$store.state.userProfile.profileImages[i].geohash
            );
            let d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
            let distance = haversine(d1, d2);
            vm.$store.state.userProfile.profileImages[
              i
            ].distance = `${distance.toFixed(0)} km`;
          }
        }
      }
    },
    //your current location
    getLocation() {
      let vm = this;

      if (vm.selectedSort === "nearest") {
        if (this.finalUserLocation !== "") {
          vm.$store.state.userProfile.profileImages = [];
          vm.$store.commit("getProfileImages", {
            uid: this.$route.query.profile_id,
            limit: 200,
            startAt: vm.profileImages.length,
            tab: vm.selectedCountName,
            orderBy: vm.selectedSort,
            geohash: vm.profileGeolocation,
            isRandom: false
          });
        } else {
          this.$store.commit("getLocationFinal");
        }
      } else {
        vm.$store.state.userProfile.profileImages = [];
        vm.$store.commit("getProfileImages", {
          uid: this.$route.query.profile_id,
          limit: 50,
          startAt: vm.profileImages.length,
          tab: vm.selectedCountName,
          orderBy: vm.selectedSort,
          geohash: vm.profileGeolocation,
          isRandom: false
        });
      }
    }

    /*  console.log('getLocation=>')
        let vm = this
        console.log('LOC=>', vm.finalUserLocation)
        if(vm.finalUserLocation === '') {
          this.$store.state.common.fetchLocLoader = true
          console.log('GET POSITION')
          if (navigator.geolocation) {
            console.log("NAVIGATOR")
              vm.$store.state.common.fetchLocLoader = false
              // console.log('!!!!!!!!!!!!!!!!!!!!!!!LOCATION IS ON')
              console.log('POSITION=>',{lat:position.coords.latitude, lng: position.coords.longitude})
              vm.$store.state.userProfile.profileGeolocation = vm.finalUserLocation
              console.log('profileGeolocation=>', vm.profileGeolocation)



              if(vm.selectedSort == 'nearest' && vm.profileGeolocation != '') {
                vm.$store.state.userProfile.maxProfileImg = -1
                vm.$store.state.userProfile.profileImages = []
                vm.visitedIndices = []
                vm.$store.commit('getProfileImages', {
                  uid: vm.uploader.uploaderId,
                  limit: 200000000000,
                  startAt: vm.profileImages.length,
                  tab: vm.selectedCountName,
                  orderBy: vm.selectedSort,
                  geohash: vm.profileGeolocation,
                  isRandom: false
                })
              }
              else {
                let arr = vm.$store.state.userProfile.profileImages
                if(arr[0].distance == '-- km' && vm.$store.state.userProfile.profileGeolocation != '') {
                  for(let i in arr){
                    if(arr[i].hasGeohash) {
                      let d1Lon = geo.decode(vm.$store.state.userProfile.profileGeolocation)
                      let d1 = {latitude:d1Lon.lat, longitude:d1Lon.lon}
                      let d2Lon = geo.decode(arr[i].geohash)
                      let d2 = {latitude:d2Lon.lat, longitude:d2Lon.lon}
                      let distance = haversine(d1, d2)
                      console.log('DISTANCE=>', distance)
                      arr[i].distance  = `${distance.toFixed(0)} km`
                    }
                  }
                }
                vm.$store.state.userProfile.profileImages = arr
              }

          }
        }
        else {
          if(vm.selectedSort == 'nearest' ) {
           // alert('WILL CALL FUNC')
            vm.$store.state.userProfile.maxProfileImg = -1
            vm.$store.state.userProfile.profileImages = []
            vm.visitedIndices = []
            vm.$store.commit('getProfileImages', {
              uid: vm.uploader.uploaderId,
              limit: 20000000000000,
              startAt: vm.profileImages.length,
              tab: vm.selectedCountName,
              orderBy: vm.selectedSort,
              geohash: vm.finalUserLocation,
              isRandom: false
            })
          }
          else {
          // alert('ELSE')
            console.log('LOC here =>', vm.finalUserLocation)
              for(let i in vm.$store.state.userProfile.profileImages){
               let arr = vm.$store.state.userProfile.profileImages[i]
                if(arr.hasGeohash && arr.geohash != '') {
                  let d1Lon = geo.decode(vm.finalUserLocation )
                  let d1 = {latitude:d1Lon.lat, longitude:d1Lon.lon}
                  let d2Lon = geo.decode(arr.geohash)
                  let d2 = {latitude:d2Lon.lat, longitude:d2Lon.lon}
                  let isM = false
                  let distance = haversine(d1, d2)
                  if(distance.toFixed(0) === '0') {
                    isM = true
                    distance = haversine(d1, d2, {unit: 'meter'})
                  }
                  else {
                   distance = JSON.parse(distance.toFixed(0))
                  }

                  console.log('DISTANCE=>', distance)
                  arr.distance  = `${JSON.stringify(distance)} ${isM? ' m': ' km'}`
                }
            }
            vm.$store.state.userProfile.profileImages = arr
            console.log('vm.$store.state.userProfile.profileImages=>', vm.$store.state.userProfile.profileImages)
          }
        } */
  },
  computed: {
    ...mapGetters([
      "hideMap",
      "user",
      "profile",
      "profileImages",
      "maxProfileImg",
      "totalCounts",
      "isbottomMenuOpen",
      "selectedUploader",
      "profileGeolocation",
      "fetchLocLoader",
      "finalUserLocation",
      "isLoggedIn"
    ]),
    getImageHeight() {
      if (this.selectedCount === "shared") {
        return `15em`; //'28.86056971514243vh'
      } else {
        return `30em`; //'63.41829085457272vh'
      }
    },
    profileImageValidator() {
      // let re = /([a-z\-_0-9\/\:\.]*\.(jpg|jpeg|png|gif))/i
      return this.profile.photoURL;
    },
    selectedCountName() {
      return this.selectedCount;
    },
    newProfileLink() {
      let newProfileUrl = this.profile.photoURL.replace("http", "https");
      return newProfileUrl;
    }
  },
  components: {
    InfiniteLoading,
    bottom,
    mapView
  },
  filters: {
    desc_filter(val) {
      return val.substring(0, 280) + "...";
    }
  }
};
</script>
<style lang="scss" scoped>
#upload_widget_opener {
  cursor: pointer;
  color: blue;
}
.v-lazy-image {
  filter: blur(5px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
@import "../assets/scss/profile/profile";
#map {
  background: #eeeeee !important;
  width: 100%;
  height: 66vh;
  z-index: 1;
}
select {
  font-size: 16px !important;
}
.profile-container {
  .yellow--text {
    color: #febd35 !important;
  }

  ::-webkit-scrollbar {
    display: none !important;
  }

  .top-div {
    z-index: 2;

    height: 45em;
    //height: 54em; //765px; //105vh;
    width: 100%;
    background-color: rgb(222, 222, 222);

    .spotlight {
      font-weight: bold;
      padding-top: 2.375em;
      margin-bottom: 1.375em;
      font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
        "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
        "Helvetica Neue", sans-serif;
      font-size: 1.25em;
      color: #333333;
      text-align: center;
      letter-spacing: 0.125em;
    }

    img {
      max-width: 100%;
      height: 17.857em; //250px; //34.48275862068966vh;
    }

    .user-details {
      position: relative;
      //padding: 1em 0;
      padding-left: 1em;
      padding-right: 1em;
      padding-bottom: 1em;
      background-color: white;
      height: auto; //17em; //33.48275862068966vh;
      margin-top: -0.8em; //-1vh;
      box-shadow: 0 -20px 50px 0 rgba(0, 0, 0, 0.1);

      .edit-profile {
        cursor: pointer;
        position: absolute;
        width: 3em;
        height: 3em;
        background-color: #00b0ff;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .name {
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        font-size: 3.125em;
        color: #333333;
        text-align: left;
        font-weight: 600;
        margin-left: 30px;
        line-height: 1em;
        padding-top: 0.5em;
      }

      .location-and-travel-list {
        margin-top: 0.8em;
        padding: 0 2.3em;
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        display: flex;
        justify-content: space-between;
        font-size: 0.875em;
        font-weight: 100;
        color: #616161;

        .city-name {
          display: flex;
          align-items: center;
          i {
            font-size: 1em;
            color: black;
            margin-right: 5px;
          }
        }
      }

      /* About: */
      .description {
        margin: 0.5em 0;
        padding: 0 2.3em;
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        font-size: 0.75em;
        color: #616161;
        text-align: left;
        letter-spacing: 1px;
      }
    }

    .counts {
      font-size: 0.7em;
      height: 7.929em; //13.718140929535233vh;
      background-color: #ffffff;
      box-shadow: inset 0 40px 40px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-around;
      align-items: center;

      .count-number-container {
        opacity: 0.4;
        cursor: pointer;
      }
      .count-number {
        font-weight: bold;
      }
      .is-selected-count-true {
        color: #bd10e0;
        font-weight: 700;
        // 989a9c
      }
    }

    .count-details {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 10.429em; //17.991004497751124vh;
      background-color: white;
      box-shadow: 0 50px 50px 0 rgba(0, 0, 0, 0.1);
      margin-top: 45px;

      .selected-count {
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        margin-top: 0.5em;
        font-size: 1.8em;
        font-weight: 700;
        color: #bd10e0;
        letter-spacing: 2px;
      }
      .selected-number {
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        font-size: 2.3em;
        font-weight: 700;
        color: #333333;
        text-align: center;
        margin-top: -0.5em;
        letter-spacing: 6px;
      }

      .details-other-header {
        font-size: 0.7em;
        font-weight: 100;
        opacity: 0.4;
        color: #000000;
      }

      .count-number-details {
        font-size: 0.75em;
        font-weight: 700;
        color: #000000;
      }
    }
    @media screen and (min-width: 1024px) {
      .dropdown-container {
        margin-top: 12.071em !important;
      }
    }
    .dropdown-container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      position: absolute;
      height: 4.643em; //8vh;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.6);
      margin-top: 13.571em; //190.6px;//27.6vh;

      .showing-select {
        margin-top: 0.9em;
        font-size: 0.75em;
        color: black;
      }

      .showing-name {
        //width: 70%;
        position: relative;
        margin-top: 0.571em; //1vh;
        font-weight: bold;
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        color: #4a90e2;
        //
        display: flex;
        align-items: center;
        select {
          outline: none;
          padding-right: 20px;
        }
        i {
          position: absolute;
          left: 85%;
          color: #4a90e2;
        }
      }
    }

    .false-class {
      width: 100%;
      height: 1px;
      background-color: transparent;
    }

    .images-container {
      img {
        width: 100%;
        //height: 63.41829085457272vh;
        object-fit: cover;
      }
      cursor: pointer;
      position: absolute;
      margin-top: 19em; //280px; //40vh;
      overflow-y: scroll;
      overflow-x: hidden;
      height: 90vh; //90vh;
    }

    .image-details {
      height: 9.8em; //14.16791604197901vh;
      background-color: black;
      margin-top: -0.7em; //-1vh;
      margin-bottom: 1.2em; //2vh;
      font-size: 0.75em;

      .number-img-det {
        font-weight: 700;
      }
      .label-img-det {
        font-weight: 100;
        opacity: 0.6;
      }

      i {
        font-size: 1.3em;
      }
    }
  }

  .bottom-div {
    z-index: 1;
    height: 125vh;
    background-color: #989a9c;
  }

  .bottom-container {
    bottom: 0;
    right: 0;
    position: absolute;
  }

  .footer {
    background: linear-gradient(
      -180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.61) 62%
    );
    height: 18.740629685157423vh;
    z-index: 8;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    padding-top: 120px;
    align-items: center;
    justify-content: center;
    padding-bottom: 3.7481259370314843vh;
    i {
      font-size: 30px;
    }
  }

  .menu {
    top: 100%;
    position: absolute;
  }
}

.dropdown-container {
  position: relative;
  text-align: right;
  outline: none;

  .more-vert-icon {
    cursor: pointer;
  }

  .dropdown-card-container {
    background: #ffffff;
    position: absolute;
    right: 0.2em;
    padding: 0.515em 1em;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    border-radius: 8px;
  }

  .logout-text {
    font-size: 0.818em;
    font-weight: 600;
    color: #666666;
    cursor: pointer;
  }
}
</style>




























// WEBPACK FOOTER //
// profile.vue?063f5837